"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RTTI_Identifier = exports.IdentifierUseKind = void 0;
var t = __importStar(require("io-ts"));
var RTTI_Extension_1 = require("./RTTI_Extension");
var RTTI_Element_1 = require("./RTTI_Element");
var RTTI_CodeableConcept_1 = require("./RTTI_CodeableConcept");
var RTTI_uri_1 = require("../Scalar/RTTI_uri");
var RTTI_Period_1 = require("./RTTI_Period");
var RTTI_Reference_1 = require("./RTTI_Reference");
var IdentifierUseKind;
(function (IdentifierUseKind) {
    IdentifierUseKind["_usual"] = "usual";
    IdentifierUseKind["_official"] = "official";
    IdentifierUseKind["_temp"] = "temp";
    IdentifierUseKind["_secondary"] = "secondary";
    IdentifierUseKind["_old"] = "old";
})(IdentifierUseKind = exports.IdentifierUseKind || (exports.IdentifierUseKind = {}));
var EnumType_1 = require("../../EnumType");
exports.RTTI_Identifier = t.recursion('IIdentifier', function () {
    return t.partial({
        id: t.string,
        extension: t.array(RTTI_Extension_1.RTTI_Extension),
        use: (0, EnumType_1.createEnumType)(IdentifierUseKind, 'IdentifierUseKind'),
        _use: RTTI_Element_1.RTTI_Element,
        type: RTTI_CodeableConcept_1.RTTI_CodeableConcept,
        system: RTTI_uri_1.RTTI_uri,
        _system: RTTI_Element_1.RTTI_Element,
        value: t.string,
        _value: RTTI_Element_1.RTTI_Element,
        period: RTTI_Period_1.RTTI_Period,
        assigner: RTTI_Reference_1.RTTI_Reference
    });
});
//# sourceMappingURL=RTTI_Identifier.js.map